import { DOCUMENT, inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

export const authGuard: CanMatchFn = async () => {
	const auth = inject(AuthService);
	const document = inject(DOCUMENT);

	if (await auth.checkAuth()) {
		return true;
	}

	const redirectTo = encodeURIComponent(document.location.href);
	document.location.href = `${environment.appUrl}auth/login?redirectTo=${redirectTo}`;

	return false;
};
